/**
 * ArticleLayoutAnalytical - Analytical article layout wrapper
 * Applies CSS class for sidebar-style analytical layout
 */
import React from 'react';

const ArticleLayoutAnalytical = ({ children }) => {
    return (
        <div className="article-layout article-layout--analytical">
            <div className="article-layout__body">
                {children}
            </div>
        </div>
    );
};

export default ArticleLayoutAnalytical;
